import { api } from '@/api'
import { endpoints } from '@/api/endpoints'
import {
  GetRequestsParams,
  GetRequestsResponse,
  MutationRequestParams,
  CreateRequestPayload,
  ApiRequest,
  InteractRequestsCountResponse,
  PaymentLinkInfoResponse,
  PaymentLinkClaimPayload,
  PaymentLinkClaimResponse,
} from './requestTypes'

/**
 * Get payment requests history with pagination
 */
async function fetchPaymentRequestsHistory(
  params: GetRequestsParams = {},
): Promise<GetRequestsResponse> {
  const response = await api.get<GetRequestsResponse>(
    endpoints.transfer.fetchPaymentRequestsHistory,
    {
      params,
    },
  )

  return response.data
}

/**
 * Create a new payment request
 */
async function createInteractRequest(
  payload: CreateRequestPayload,
): Promise<ApiRequest> {
  const response = await api.post<ApiRequest>(
    endpoints.transfer.createInteractRequest,
    payload,
  )

  return response.data
}

/**
 * Decline a payment request
 */
async function declineRequest({
  requestId,
}: MutationRequestParams): Promise<void> {
  const response = await api.post<void>(
    endpoints.transfer.declineRequest(requestId),
  )

  return response.data
}

/**
 * Cancel a payment request
 */
async function cancelRequest({
  requestId,
}: MutationRequestParams): Promise<void> {
  const response = await api.post<void>(
    endpoints.transfer.cancelRequest(requestId),
  )

  return response.data
}

/**
 * Accept a payment request
 */
async function acceptRequest({
  requestId,
}: MutationRequestParams): Promise<void> {
  const response = await api.post<void>(
    endpoints.transfer.acceptRequest(requestId),
  )

  return response.data
}

/**
 * Send reminder for a payment request
 */
async function remindRequest({
  requestId,
}: MutationRequestParams): Promise<void> {
  const response = await api.post<void>(
    endpoints.notifier.remindRequest(requestId),
  )

  return response.data
}

/**
 * Take back a payment link (initiator only)
 */
async function takeBackRequest({
  requestId,
}: MutationRequestParams): Promise<void> {
  const response = await api.post<void>(
    endpoints.transfer.takeBackRequest(requestId),
  )

  return response.data
}

/**
 * Get count of pending interact requests
 */
async function getInteractRequestsCount(): Promise<InteractRequestsCountResponse> {
  const response = await api.post<InteractRequestsCountResponse>(
    endpoints.transfer.interactRequestsCount,
  )

  return response.data
}

/**
 * Get payment link info for claim preview
 */
async function getPaymentLinkInfo(
  code: string,
): Promise<PaymentLinkInfoResponse> {
  const response = await api.get<PaymentLinkInfoResponse>(
    endpoints.paymentLink.info(code),
  )

  return response.data
}

/**
 * Claim a payment link
 */
async function claimPaymentLink(
  payload: PaymentLinkClaimPayload,
): Promise<PaymentLinkClaimResponse> {
  const response = await api.post<PaymentLinkClaimResponse>(
    endpoints.paymentLink.claim,
    payload,
  )

  return response.data
}

export const requestApi = {
  fetchPaymentRequestsHistory,
  createInteractRequest,
  declineRequest,
  cancelRequest,
  acceptRequest,
  remindRequest,
  takeBackRequest,
  getInteractRequestsCount,
  getPaymentLinkInfo,
  claimPaymentLink,
}
